export default {
  data() {

    var _orderPriorityList = [
      { name: "紧急(P5)", id: 5 },
      { name: "P4", id: 4 },
      { name: "P3", id: 3 },
      { name: "P2", id: 2 },
      { name: "一般(P1)", id: 1 }
    ];

    return {
      orderPriorityList: _orderPriorityList
    }
  },

  methods: {
    // 获取优先级名称
    _getPriorityName(id) {
      if ( !id ) {
        return null;
      }

      for (var i = 0; i < this.orderPriorityList.length; i++) {
        if (this.orderPriorityList[i].id == id) {
          return this.orderPriorityList[i].name
        }
      }

      return 'P' + id;
    },

    isAudio(attachment) {
      var suffixes = ['.wav'];

      return this.isAttachmentType(attachment, suffixes);
    },

    isVideo(attachment) {
      var suffixes = ['.mp4'];

      return this.isAttachmentType(attachment, suffixes);
    },

    isImage(attachment) {
      var suffixes = ['.webp', '.bmp', '.tif', '.png', '.gif', '.jpe', '.jpeg', '.jpg', '.wbmp'];

      return this.isAttachmentType(attachment, suffixes);
    },

    isAttachmentType(attachment, suffixes) {
      if ( !attachment ) {
        return false;
      }

      var fileName;
      if ( typeof attachment == "string" ) {
        fileName = attachment;
      } else {
        fileName = attachment.fileName;
      }

      if (!fileName) {
        return false;
      }

      for (var i = 0; i < suffixes.length; i++) {
        if (fileName.toLowerCase().indexOf(suffixes[i]) > 0) {
          return true;
        }
      }

      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/MixinTicketEventUtil.js